/* ============================================================
   Konverso optimized — deferred helpers
   - sticky ATC click forwarding
   - section reveal animations (IntersectionObserver)
   - external links target=_blank (event delegation, no eager loop)
   ============================================================ */
(function () {
  'use strict';

  // ---- 1) Sticky ATC button forwards click to main product-form ----
  function wireStickyAtc() {
    var productForm = document.querySelector('product-form[data-main="true"]');
    if (!productForm) return;
    var btns = document.querySelectorAll('[id^="SectionAtcBtn-"]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) { productForm.handleSubmit(e); });
    });
  }

  // ---- 2) External links open in new tab (delegated, no upfront loop) ----
  function wireExternalLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      if (link.hostname && link.hostname !== window.location.hostname) {
        if (!link.target) link.target = '_blank';
        if (!link.rel)    link.rel = 'noreferrer noopener';
      }
    }, { passive: true });
  }

  // ---- 3) Section reveal animations (only if enabled) ----
  function wireRevealAnimations() {
    if (!window.__konverso_loadAnimations) return;

    var stickyAtc = document.querySelector('.sticky-atc');
    var bottomMargin = 50 + (stickyAtc ? stickyAtc.clientHeight : 0);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate--shown');
        } else if (window.__konverso_repeatAnimations) {
          entry.target.classList.remove('animate--shown');
        }
      });
    }, { rootMargin: '0px 0px -' + bottomMargin + 'px 0px' });

    function init(root, fromEditor) {
      root = root || document;
      var els = root.querySelectorAll('.animate-section');
      if (!els.length) return;
      els.forEach(function (el) {
        if (fromEditor) { el.classList.add('animate--shown'); return; }
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { init(e.target, true); });
      document.addEventListener('shopify:section:reorder', function () { init(document, true); });
    }
  }

  // Run on idle so we never block main thread / LCP
  function runDeferred() {
    wireStickyAtc();
    wireExternalLinks();
    wireRevealAnimations();
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(runDeferred, { timeout: 2000 });
  } else {
    setTimeout(runDeferred, 1);
  }
})();
